import { useCallback } from 'react';
import styles from './styles.scss';
import moment from 'moment-timezone';
import cn from 'classnames';
import { List } from 'immutable';
import { trackDateSelection } from '../../../../../../../utils/journey-tracking';

const Periods = ({ event, setEvent, setTickets, selectedOccurrence, settings }) => {
  const dates = {
    morningTimes: [],
    afternoonTimes: [],
    eveningTimes: [],
    nightTimes: [],
  };

  if (!selectedOccurrence) return <span />;

  const handleRecordOnClick = useCallback(
    ({ tickets = List(), eventTime }) => {
      const hasAvailability = eventTime.get('tickets').some((ticket) => ticket.get('status') === 'onsale');

      if (!hasAvailability) return;
      setEvent(eventTime);
      setTickets(tickets);

      // Track date selection
      trackDateSelection(eventTime);
    },
    [setEvent, setTickets, trackDateSelection]
  );

  const allDayEvent = event.get('all_day_event');

  const sortedSelectedOccurrence = selectedOccurrence.timeEntries.sort((a, b) => {
    const dateA = moment(a.get('start_date')).tz(a.get('timezone'));
    const dateB = moment(b.get('start_date')).tz(b.get('timezone'));
    return dateA - dateB;
  });

  sortedSelectedOccurrence.forEach((time) => {
    const start = moment(time.get('start_date')).tz(time.get('timezone'));
    const timezone = time.get('timezone');

    const maxMorningTime = moment(start).tz(timezone).hours(13).startOf('hour');
    const maxAfternoonTime = moment(start).tz(timezone).hours(18).startOf('hour');
    const maxEveningTime = moment(start).tz(timezone).hours(20).startOf('hour');
    const maxNightTime = moment(start).tz(timezone).hours(23).startOf('hour');

    const formattedStartTime = start.format(settings.get('checkoutTimeFormat'));
    const isAvailable = time.get('tickets').some((ticket) => ticket.get('status') === 'onsale');

    if (start.isBefore(maxMorningTime)) {
      dates.morningTimes.push({
        event: time,
        dateTime: formattedStartTime,
        statusAvailable: isAvailable,
        tickets: time.get('tickets'),
        id: time.get('id'),
      });
    } else if (start.isSameOrBefore(maxAfternoonTime) && start.isSameOrAfter(maxMorningTime)) {
      dates.afternoonTimes.push({
        event: time,
        dateTime: formattedStartTime,
        statusAvailable: isAvailable,
        tickets: time.get('tickets'),
        id: time.get('id'),
      });
    } else if (start.isSameOrBefore(maxEveningTime) && start.isSameOrAfter(maxAfternoonTime)) {
      dates.eveningTimes.push({
        event: time,
        dateTime: formattedStartTime,
        statusAvailable: isAvailable,
        tickets: time.get('tickets'),
        id: time.get('id'),
      });
    } else if (start.isSameOrBefore(maxNightTime) && start.isSameOrAfter(maxEveningTime)) {
      dates.nightTimes.push({
        event: time,
        dateTime: formattedStartTime,
        statusAvailable: isAvailable,
        tickets: time.get('tickets'),
        id: time.get('id'),
      });
    }
  });

  if (allDayEvent) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      {dates.morningTimes.length > 0 && (
        <div className={styles.period}>
          <div className={styles.title}>{settings.get('timeBasedMorningPeriodText')}</div>
          <div className={styles.line}>
            {dates.morningTimes.map((time) => (
              <div
                key={time.id}
                className={cn(styles.item, { [styles.soldOut]: !time.statusAvailable, [styles.selected]: time.id === event.get('id') })}
                onClick={() => handleRecordOnClick({ eventTime: time.event, tickets: time.tickets })}
              >
                {time.dateTime}
              </div>
            ))}
          </div>
        </div>
      )}
      {dates.afternoonTimes.length > 0 && (
        <div className={styles.period}>
          <div className={styles.title}>{settings.get('timeBasedAfternoonPeriodText')}</div>
          <div className={styles.line}>
            {dates.afternoonTimes.map((time) => (
              <div
                key={time.id}
                className={cn(styles.item, { [styles.soldOut]: !time.statusAvailable, [styles.selected]: time.id === event.get('id') })}
                onClick={() => handleRecordOnClick({ eventTime: time.event, tickets: time.tickets })}
              >
                {time.dateTime}
              </div>
            ))}
          </div>
        </div>
      )}
      {dates.eveningTimes.length > 0 && (
        <div className={styles.period}>
          <div className={styles.title}>{settings.get('timeBasedEveningPeriodText')}</div>
          <div className={styles.line}>
            {dates.eveningTimes.map((time) => (
              <div
                key={time.id}
                className={cn(styles.item, { [styles.soldOut]: !time.statusAvailable, [styles.selected]: time.id === event.get('id') })}
                onClick={() => handleRecordOnClick({ eventTime: time.event, tickets: time.tickets })}
              >
                {time.dateTime}
              </div>
            ))}
          </div>
        </div>
      )}
      {dates.nightTimes.length > 0 && (
        <div className={styles.period}>
          <div className={styles.title}>{settings.get('timeBasedNightPeriodText')}</div>
          <div className={styles.line}>
            {dates.nightTimes.map((time) => (
              <div
                key={time.id}
                className={cn(styles.item, { [styles.soldOut]: !time.statusAvailable, [styles.selected]: time.id === event.get('id') })}
                onClick={() => handleRecordOnClick({ eventTime: time.event, tickets: time.tickets })}
              >
                {time.dateTime}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Periods;
